import * as actionTypes from '../actions/types';

import axios from '../http-common';

import {
    validarArregloInternaciones,
    actualizarRequeridosEsValido,
} from './nuevaPresentacion.js';

export const recuperarInfoNroInternacion = (codPrestador, nroInternacion) => (
    dispatch,
    getState
) => {
    if (getState().nuevaPresentacionReducer.tipoPresentacionSeleccionada===3){
        recuperarInfoAsociado(nroInternacion)(dispatch);
        return;
    }

    axios
        .get(
            '/prestadores/' +
                codPrestador +
                '/internaciones/' +
                nroInternacion
        )
        .then((response) => {
            dispatch({
                type: actionTypes.RECUPERAR_INFO_NRO_INTERNACION,
                payload: response.data,
            });
        })
        .catch((reason) => {
            dispatch({
                type: actionTypes.RECUPERAR_INFO_NRO_INTERNACION,
                payload: {
                    nroInternacion: nroInternacion,
                    nombreCompleto: '',
                    nroSocio: '',
                },
            });
        });
};

export const recuperarInfoAsociado = (dniAsociado) => (
    dispatch
) => {
    axios
        .get(
            "/prestadores/internaciones/" +
                dniAsociado
        )
        .then((response) => {
            if (!response.data.resultado){
                throw new Error();
            }
            dispatch({
                type: actionTypes.RECUPERAR_INFO_NRO_INTERNACION,
                payload: {
                    nombreCompleto: response.data.nombreCompleto,
                    nroInternacion: dniAsociado,
                    nroDocumento: dniAsociado,
                    nroSocio: response.data.nroSocio,
                },
            });
        })
        .catch((reason) => {
            dispatch({
                type: actionTypes.RECUPERAR_INFO_NRO_INTERNACION,
                payload: {
                    nroInternacion: dniAsociado,
                    nroDocumento: dniAsociado,
                    nombreCompleto: "",
                    nroSocio: "",
                },
            });
        });
};

export const actualizarInfoAsociado = (internacion, index) => (
    dispatch,
) => {
    axios
        .get(
            "/prestadores/internaciones/" +
                internacion.nroInternacion
        )
        .then((response) => {
            if (!response.data.resultado){
                throw new Error();
            }
            dispatch({
                type: actionTypes.ACTUALIZAR_INFO_NRO_INTERNACION,
                payload: {
                    index: index,
                    nombreCompleto: response.data.nombreCompleto,
                    nroInternacion: internacion.nroInternacion,
                    nroDocumento: internacion.nroInternacion,
                    nroSocio: response.data.nroSocio,
                    modificada: true,
                },
            });
            dispatch(validarInternaciones());
        })
        .catch((reason) => {
            dispatch({
                type: actionTypes.ACTUALIZAR_INFO_NRO_INTERNACION,
                payload: {
                    index: index,
                    nombreCompleto: "",
                    nroInternacion: internacion.nroInternacion,
                    nroDocumento: internacion.nroInternacion,
                    modificada: true,
                },
            });
            dispatch(validarInternaciones());
        });
};

export const actualizarInfoInternacion = (internacion, index) => (
    dispatch,
    getState
) => {
    if (getState().nuevaPresentacionReducer.tipoPresentacionSeleccionada===3){
        actualizarInfoAsociado(internacion, index)(dispatch);
        return;
    }

    const codPrestador = getState().nuevaPresentacionReducer
        .prestadorSeleccionado.codPrestador;
    axios
        .get(
            '/prestadores/' +
                codPrestador +
                '/internaciones/' +
                internacion.nroInternacion
        )
        .then((response) => {
            dispatch({
                type: actionTypes.ACTUALIZAR_INFO_NRO_INTERNACION,
                payload: {
                    index: index,
                    nombreCompleto: response.data.nombreCompleto,
                    nroSocio: response.data.nroSocio,
                },
            });
            dispatch(validarInternaciones());
        })
        .catch((reason) => {
            dispatch({
                type: actionTypes.ACTUALIZAR_INFO_NRO_INTERNACION,
                payload: {
                    index: index,
                    nombreCompleto: '',
                    nroSocio: '',
                },
            });
            dispatch(validarInternaciones());
        });
};

export const obtenerTempIdParaInternacion = () => (dispatch) => {
    axios.get('/presentaciones/internaciones/id').then((response) => {
        dispatch({
            type: actionTypes.GUARDAR_TEMP_ID,
            payload: response.data,
        });
    });
};

export const internacionParaActualizar = (internacion) => (dispatch) => {
    dispatch({
        type: actionTypes.INTERNACION_PARA_ACTUALIZAR,
        payload: internacion,
    });
};

export const setCargaArchivosInternacion = (estaCargando) => (dispatch) => {
    dispatch({
        type: actionTypes.SET_CARGA_ARCHIVOS_INTERNACION,
        payload: estaCargando,
    });
};

export const reiniciarNuevaPresentacion = () => (dispatch) => {
    dispatch({ type: actionTypes.REINICIAR_DATOS_INTERNACION });
};

export const validarInternaciones = () => (dispatch, getState) => {
    const internaciones = getState().nuevaPresentacionReducer.internaciones;
    const archivosValidos = validarArregloInternaciones(internaciones);
    dispatch(actualizarRequeridosEsValido('internaciones', archivosValidos));
};
